document.addEventListener("click", (event) => {
  // Abrir modal
  const openButton = event.target.closest(".product-info-button");

  if (openButton) {
    document.getElementById(openButton.dataset.modal)?.showModal();

    return;
  }

  // Cerrar modal
  const closeButton = event.target.closest("[data-close]");

  if (closeButton) {
    closeButton.closest("dialog")?.close();
    return;
  }

  // Cerrar haciendo click fuera
  if (event.target instanceof HTMLDialogElement) {
    event.target.close();
  }
});
